export default {
  // Xarefit Data
  'dashboardandanalysis.analysis.unique-consumption-per-monthly': '每月不重複消費人次',
  'dashboardandanalysis.analysis.unique-consumption-per-monthly.introduce':
    '每個unique user當月有購買行為總計',
  'dashboardandanalysis.analysis.current-month-unique-consumption': '當月不重複消費人次',
  'dashboardandanalysis.analysis.daily-number-of-people-in-and-out-of-venues': '每日場館進出人數',
  'dashboardandanalysis.analysis.monthly-number-of-people-in-and-out-of-venues': '每月場館進出人數',
  'dashboardandanalysis.analysis.receving-coupon-amount-per-monthly': '每月領取體驗卷人數',
  'dashboardandanalysis.analysis.used-coupon-amount-per-monthly': '每月使用體驗卷人數',
  'dashboardandanalysis.analysis.registed-by-coupon': '體驗卷註冊會籍比例',
  'dashboardandanalysis.analysis.cancel-membership-amount-per-month': '每月取消會籍人數',
  'dashboardandanalysis.analysis.cancel-membership-amount-per-month.introduce': '每月取消會籍人數',
  'dashboardandanalysis.analysis.total-subscribe-membership-amount': '訂閱會籍總人數',
  'dashboardandanalysis.analysis.subscribe-membership-amount-per-month': '每月訂閱會籍人數',
  'dashboardandanalysis.analysis.subscribe-membership-amount-per-month.introduce':
    '每月訂閱會籍人數',
  'dashboardandanalysis.analysis.subscribe-membership-amount-per-day': '每日訂閱會籍人數',
  'dashboardandanalysis.analysis.new-subscribe-membership-amount-per-month': '每月新增訂閱會議人數',
  'dashboardandanalysis.analysis.number-of-entrances-and-exits-per-month': '每月進出場館次數',
  'dashboardandanalysis.analysis.number-of-entrances-and-exits-per-month.introduce':
    '每月進出場館次數',
  // Original Data
  'dashboardandanalysis.analysis.test': '工專路 {no} 號店',
  'dashboardandanalysis.analysis.introduce': '指標說明',
  'dashboardandanalysis.analysis.total-sales': '總銷售額',
  'dashboardandanalysis.analysis.day-sales': '日銷售額',
  'dashboardandanalysis.analysis.visits': '訪問量',
  'dashboardandanalysis.analysis.visits-trend': '訪問量趨勢',
  'dashboardandanalysis.analysis.visits-ranking': '門店訪問量排名',
  'dashboardandanalysis.analysis.day-visits': '日訪問量',
  'dashboardandanalysis.analysis.week': '周同比',
  'dashboardandanalysis.analysis.day': '日同比',
  'dashboardandanalysis.analysis.payments': '支付筆數',
  'dashboardandanalysis.analysis.conversion-rate': '轉化率',
  'dashboardandanalysis.analysis.operational-effect': '運營活動效果',
  'dashboardandanalysis.analysis.sales-trend': '銷售趨勢',
  'dashboardandanalysis.analysis.sales-ranking': '門店銷售額排名',
  'dashboardandanalysis.analysis.all-year': '全年',
  'dashboardandanalysis.analysis.all-month': '本月',
  'dashboardandanalysis.analysis.all-week': '本周',
  'dashboardandanalysis.analysis.all-day': '今日',
  'dashboardandanalysis.analysis.search-users': '搜索用戶數',
  'dashboardandanalysis.analysis.per-capita-search': '人均搜索次數',
  'dashboardandanalysis.analysis.online-top-search': '線上熱門搜索',
  'dashboardandanalysis.analysis.the-proportion-of-sales': '銷售額類別占比',
  'dashboardandanalysis.channel.all': '全部渠道',
  'dashboardandanalysis.channel.online': '線上',
  'dashboardandanalysis.channel.stores': '門店',
  'dashboardandanalysis.analysis.sales': '銷售額',
  'dashboardandanalysis.analysis.traffic': '客流量',
  'dashboardandanalysis.table.rank': '排名',
  'dashboardandanalysis.table.search-keyword': '搜索關鍵詞',
  'dashboardandanalysis.table.users': '用戶數',
  'dashboardandanalysis.table.weekly-range': '周漲幅',
};
